import { GAME } from '../config/constants';
import { OFFICIAL_POST_IT_SLOTS } from './bossFinalOfficialCarSlots';

export const BOSS_FINAL_NOTE_COUNT = OFFICIAL_POST_IT_SLOTS.length;
export const CAR_SCALE = 1180 / 1857;
export const CAR_ORIGIN = Object.freeze({ x: 50, y: (750 - 896 * CAR_SCALE) / 2 });
export const BOSS_FINAL_NOTE_COLORS = Object.freeze([
    0xffeb48, 0xffb042, 0xf3bdd5, 0xbedeff, 0xbdfaa7
]);

function hash (value) {
    let current = value | 0;
    current = Math.imul(current ^ (current >>> 16), 0x45d9f3b);
    current = Math.imul(current ^ (current >>> 16), 0x45d9f3b);
    return (current ^ (current >>> 16)) >>> 0;
}
const random01 = (seed) => hash(seed) / 0xffffffff;

export function buildVisualInsights (insights, minimumCount = BOSS_FINAL_NOTE_COUNT) {
    const safeInsights = Array.isArray(insights) ? insights : [];
    const source = safeInsights.length ? safeInsights : [{ id: 'empty', grupo: '', texto: '' }];
    return Array.from({ length: Math.max(minimumCount, safeInsights.length) }, (_, index) => ({
        ...source[index % source.length],
        visualId: `${source[index % source.length].id ?? 'insight'}:${index}`,
        color: OFFICIAL_POST_IT_SLOTS[index % BOSS_FINAL_NOTE_COUNT].color,
        foldColor: OFFICIAL_POST_IT_SLOTS[index % BOSS_FINAL_NOTE_COUNT].foldColor
    }));
}

export function buildBossFinalLayout (count) {
    return Array.from({ length: count }, (_, index) => {
        const seed = hash(index + 1);
        const clusterIndex = index % 72;
        const angle = clusterIndex * 2.399963 + random01(hash(clusterIndex + 1)) * 0.25;
        const radius = 45 + Math.sqrt(clusterIndex / 72) * 280;
        const scatterSeed = hash(index % 68 + 101);
        const slotIndex = index % BOSS_FINAL_NOTE_COUNT;
        const target = OFFICIAL_POST_IT_SLOTS[slotIndex];
        return Object.freeze({
            cluster: {
                x: GAME.CENTER_X + Math.cos(angle) * radius,
                y: GAME.CENTER_Y - 8 + Math.sin(angle) * radius * 0.82
            },
            scatter: {
                x: 150 + random01(scatterSeed + 31) * 980,
                y: 210 + random01(scatterSeed + 53) * 310
            },
            car: {
                x: CAR_ORIGIN.x + target.x * CAR_SCALE,
                y: CAR_ORIGIN.y + target.y * CAR_SCALE
            },
            depth: slotIndex,
            order: random01(seed + 79)
        });
    });
}
